export default function MapOptions() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Map Options</h1>
    </div>
  );
}